export const AUTH = {
  APP_ID: '1fd8c662',
  APP_KEY: '66c6b1f34c3546b5490af834885918d7'
}